module.exports = __webpack_public_path__ + "static/media/gh.967a73b6.svg";